var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "benefitForm" } }, [
            _c(
              "div",
              {},
              [
                _c(
                  "draggable",
                  {
                    staticClass: "drag-view",
                    on: {
                      change: function($event) {
                        return _vm.changePosition()
                      }
                    },
                    model: {
                      value: _vm.policiesFormsList,
                      callback: function($$v) {
                        _vm.policiesFormsList = $$v
                      },
                      expression: "policiesFormsList"
                    }
                  },
                  [
                    _vm._l(_vm.policiesFormsList, function(text, index) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-20"
                          },
                          [
                            _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                  },
                                  [
                                    _c(
                                      "h2",
                                      {
                                        staticClass:
                                          "text-muted display-4 text-danger"
                                      },
                                      [
                                        _c("strong", [
                                          _c(
                                            "small",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(text.title))]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-6 col-md-6 col-sm-12 col-xs-12"
                                  },
                                  [
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("img", {
                                        staticClass: "img-thumbnail",
                                        attrs: { src: text.image_path }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("p", {
                                        directives: [
                                          {
                                            name: "linkified",
                                            rawName: "v-linkified:options",
                                            value: {
                                              className: "internal-link"
                                            },
                                            expression:
                                              "{ className: 'internal-link' }",
                                            arg: "options"
                                          },
                                          {
                                            name: "linkified",
                                            rawName: "v-linkified"
                                          }
                                        ],
                                        domProps: {
                                          innerHTML: _vm._s(
                                            text.contact_description
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("a", {
                                        staticClass: "internal-link",
                                        attrs: {
                                          target: "_blank",
                                          href: "mailto: + text.contact_email"
                                        }
                                      })
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "form-group" }, [
                                      _c("p", {
                                        directives: [
                                          {
                                            name: "linkified",
                                            rawName: "v-linkified:options",
                                            value: {
                                              className: "redirection-link"
                                            },
                                            expression:
                                              "{ className: 'redirection-link' }",
                                            arg: "options"
                                          },
                                          {
                                            name: "linkified",
                                            rawName: "v-linkified"
                                          }
                                        ],
                                        domProps: {
                                          innerHTML: _vm._s(text.description)
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("a", {
                                        staticClass: "redirection-link",
                                        attrs: {
                                          target: "_blank",
                                          href: text.redirection_link
                                        }
                                      })
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-6 col-md-6 col-sm-12 col-xs-12"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "form-group mt-15" },
                                      [
                                        _vm._l(text.button_array, function(
                                          btn,
                                          index
                                        ) {
                                          return [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "mt-1 btn btn-primary",
                                                attrs: {
                                                  href: btn.button_document,
                                                  target: "_blank"
                                                }
                                              },
                                              [_vm._v(_vm._s(btn.button_title))]
                                            ),
                                            _c("br")
                                          ]
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-md-12 col-sm-12 col-xs-12"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-danger pull-right",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.deletePoliciesFormsSection(
                                              text.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-trash",
                                          attrs: { "aria-hidden": "true" }
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" })
                              ])
                            ])
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [
        _vm._v("Draggable Policies And Forms List")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a7dfa68a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7dfa68a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/policiesandforms/BlockListViewPoliciesForms.vue
// module id = null
// module chunks = 